import { useMaintenanceStore } from "~/store/maintenanceStore";
import { useCategoriesStore } from "~/store/categoriesStore";
import { useI18nStore } from "~/store/i18nStore";
import { useStrapiApi } from "~/uses/useMyFetch";
import { getPagesQuery } from "~/utils/strapiQuery.utils";
import { unlocalizeUrl } from "~/utils/strings.utils";
import { useLanguageStore } from "~/store/languageStore";
import { useHeaderStore } from "~/store/headerStore";

export default defineNuxtRouteMiddleware(async (to, from) => {
  let meta;
  let redirectUrl = null;

  const fetchPageMeta = async (path) => {
    return useStrapiApi(`/pages?${getPagesQuery(unlocalizeUrl(path))}`).then(
      ({ data }) => {
        meta = data;
      },
    );
  };

  const initialPromises = () => [
    new Promise((resolve) => {
      resolve(useMaintenanceStore().fetch());
    }),
    new Promise((resolve) => {
      resolve(useCategoriesStore().fetch());
    }),
    new Promise((resolve) => {
      resolve(useI18nStore().fetch());
    }),
    new Promise((resolve) => {
      if (true === to.meta.externalSeo) {
        resolve(fetchPageMeta(to.path));
      }

      resolve();
    }),
    new Promise((resolve) => {
      resolve(
        useStrapiApi("/redirects/lookup", {
          query: {
            sourcePath: to.path,
          },
        })
          .then(({ data }) => {
            redirectUrl = data.targetPath;
          })
          .catch(() => {}),
      );
    }),
    new Promise((resolve) => {
      resolve(useHeaderStore().fetchHeaderBanner());
    }),
  ];

  if (import.meta.server) {
    useLanguageStore().setLanguage(to.name.match(/[^_]*/)[0]);

    await Promise.all(initialPromises());

    if (redirectUrl !== null) {
      return navigateTo(redirectUrl, { redirectCode: 301 });
    }

    useSeoMeta({
      title: meta?.metaTitle || _T("@Trademark"),
      description: meta?.metaDescription,
    });
  }

  if (undefined !== from.name && true === to.meta.externalSeo) {
    await fetchPageMeta(to.path);

    useSeoMeta({
      title: meta?.metaTitle || _T("@Trademark"),
      description: meta?.metaDescription,
    });
  }
});
